/**
 * This is the MemorableWord module configuration.
 * Do NOT configure routes in this file.
 * @memberOf MemorableWord Module
 * @namespace MemorableWord Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf MemorableWord Module.MemorableWord Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/login/memword/memword.config.js